import classes from './psPagination.scss';
import PropTypes from 'prop-types';

/**
 * Create a page link
 * @param {*} props 
 */
const Link = function (props) {
  return (
    <span className={classes.pageNumbers}>
    <a role='button' tabIndex={0} href='javascript:;' className={props.isSelected ? classes.isSelected : ''} onClick={() => props.onClick(props.value)} onKeyPress={() => props.onKeyPress(props.value)}>{props.value}</a>
    </span>
  );
};

class PaginationComponent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      currentPage: (props.value===undefined || props.value===1) ? 1 : props.value,
      paginationValues: [],
      paginationSpanCount: 0
    };
  }
  componentDidMount() {
    this.configurePagination(0);
  }
  componentWillReceiveProps(nextProps) {
    if(this.props.pageCount !== nextProps.pageCount){
      let paginationSpanCount=0;
      let paginationValues = [...Array(nextProps.pageScale).keys()].map(i => i + 1 + (nextProps.pageScale * paginationSpanCount))
      .filter((value) => (value <= nextProps.pageCount && value > 0));
      this.setState({...this.state,paginationValues:paginationValues,currentPage:1,paginationSpanCount});
      }
    if(this.props.currentPage && nextProps.currentPage===1 && this.props.currentPage!==nextProps.currentPage ){
      let paginationSpanCount=0;
      let paginationValues = [...Array(nextProps.pageScale).keys()].map(i => i + 1 + (nextProps.pageScale * paginationSpanCount))
      .filter((value) => (value <= this.props.pageCount && value > 0));
      this.setState({ paginationValues, paginationSpanCount, currentPage:1 });
    }
      
    // this.configurePagination(0);
    
  }
  /**
   * Configure values for pagination based on scale and count
   * @param {Number}  paginationSpanCount for current selected scale span (Suppose pageScale is 10, for 1...10 count is 0)
   * @returns {Array} paginationValues 
   */
  configurePagination = (paginationSpanCount) => {
    // let { props } = this;
    let paginationValues = [...Array(this.props.pageScale).keys()].map(i => i + 1 + (this.props.pageScale * paginationSpanCount))
      .filter((value) => (value <= this.props.pageCount && value > 0));
    this.setState({ ...this.state, paginationValues, paginationSpanCount });
    return paginationValues;
  }

  /**
   * On click of next, select next value
   */
  onNext = () => {
    let currentPage = this.state.currentPage + 1;
    if (currentPage > this.state.paginationValues[this.props.pageScale - 1]) {
      let paginationSpanCount = this.state.paginationSpanCount + 1;
      this.configurePagination(paginationSpanCount);
    }
    this.onValueSelect(currentPage);
  };

  /**
   * On click of previous, select previous value
   */
  onPrevious = () => {
    let currentPage = this.state.currentPage - 1;
    if (currentPage < this.state.paginationValues[0]) {
      let paginationSpanCount = this.state.paginationSpanCount - 1;
      this.configurePagination(paginationSpanCount);
    }
    this.onValueSelect(currentPage);
  };
  /**
    * increase page span to next count
    */
  onNextPageSpan() {
    let paginationSpanCount = this.state.paginationSpanCount + 1;
    let paginationValues = this.configurePagination(paginationSpanCount);
    this.onValueSelect(paginationValues[0]);
  }

  /**
    * decrease page span to next count
    */
  onPreviousPageSpan = () => {
    let paginationSpanCount = this.state.paginationSpanCount - 1;
    let paginationValues = this.configurePagination(paginationSpanCount);
    this.onValueSelect(paginationValues[0]);
  }

  /**
   * Select the required page index and send it to parent
   */
  onValueSelect = (value) => {
    this.setState({ currentPage: value });
    this.props.getCurrentIndex(value);
  };

  /**
   * Render required page numbers, render component
   */
  renderPageNumbers = () => {
    let { props } = this;
    return this.state.paginationValues.map((paginationValue) => {
      if (paginationValue === this.state.currentPage) {
        return (<Link onClick={this.onValueSelect} onKeyPress={this.onValueSelect} value={paginationValue} isSelected />);
      } else {
        return (<Link onClick={this.onValueSelect} onKeyPress={this.onValueSelect} value={paginationValue} isSelected={false} />);
      }
    });
  };


  render() {
    let { props } = this;
    let maxIndexCount = props.pageCount > props.pageScale ? Math.ceil(props.pageCount / props.pageScale) - 1 : 0;
    if (props.pageCount <= 1) {
      return null;
    } else {
      return (
        <div className={classes.PaginationComponent}>
          <div className='row'>
            <ul className={classes.paginationUlTag}>
              {this.state.currentPage !== 1 ? <li className={classes.buttonStyle + ' col-xs-2 '}>
              <a role='button'  tabIndex={0}  href="javascript:void(0)" onClick={() => this.onPrevious()} onKeyPress={() => this.onPrevious()} aria-label="Previous page"><i className={'fas fa-chevron-left ' + classes.arrowColorLeft} /></a>
              </li> : <li className={classes.buttonStyle + ' col-xs-2'}>
                <a role='button' aria-disabled aria-label="Previous page"> <i className={'fas fa-chevron-left ' + classes.arrowColorLeftDisabled} /></a>
              </li>}
              <li className={this.state.currentPage === 1 ? 'col-xs-8 ' : this.state.paginationSpanCount !== 0 ? 'col-xs-8 ' : 'col-xs-8 '}>
                {this.renderPageNumbers()}
              </li>
              {this.state.currentPage !== props.pageCount ? <li className={classes.buttonStyle + ' col-xs-2 '}>
              <a role='button' tabIndex={0}  href="javascript:void(0)" onClick={() => this.onNext()} onKeyPress={() => this.onNext()} aria-label="Next page"><i className={'fas fa-chevron-right ' + classes.arrowColorRight} /></a>
              </li> : <li className={classes.buttonStyle + ' col-xs-2 '}>
                <a role='button' aria-disabled aria-label="Next page"><i className={'fas fa-chevron-right ' + classes.arrowColorRightDisabled} /></a>
              </li> }
            </ul>
          </div>
        </div>
      );
    }
  }
}

export default PaginationComponent;


PaginationComponent.propTypes = {
  pageCount: PropTypes.number.isRequired,
  getCurrentIndex: PropTypes.func.isRequired
};

PaginationComponent.defaultProps = {
  pageCount: 0,
  pageScale: 10
};
